.link {
  font-size: 14px;
  font-weight: 300;
  line-height: 24px;
  text-decoration: underline;
}

@media screen and (width >= 1024px) {
  .screen {
    font-size: 15px;
  }
}

@container press-release-root (min-width: 1024px) {
  .pressReleaseRoot {
    font-size: 15px;
  }
}
